module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-thanks"
  }, [_c('div', {
    staticClass: "modal__overlay",
    on: {
      "click": _vm.closeThanks
    }
  }), _c('div', {
    staticClass: "modal-thanks__container"
  }, [_c('div', {
    staticClass: "modal-thanks__close",
    on: {
      "click": _vm.closeThanks
    }
  }, [_c('span'), _c('span')]), _c('div', {
    staticClass: "modal-thanks__content"
  }, [_c('div', {
    staticClass: "modal-thanks__logo-container"
  }, [_c('Icon', {
    staticClass: "modal-thanks__logo",
    attrs: {
      "name": "matt_logo-01"
    }
  })], 1), _vm._m(0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-thanks__text"
  }, [_c('h2', [_vm._v("Thank you!")]), _c('p', [_vm._v("You are all set! Please download the form below for a faster visit!")]), _c('a', {
    staticClass: "modal-thanks__link",
    attrs: {
      "href": "https://www.mattiacioortho.com/wp-content/uploads/Mouth-Guard-Permission-and-Release-Form-2017-OTHER.pdf"
    }
  }, [_vm._v("Download the Form")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f42a81b","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/modal/modal-thanks/modal-thanks.pug
// module id = 703
// module chunks = 1